import AuthRoutes from "../components/pages/auth/AuthRoute";
import DashboardRoutes from "../components/pages/dashboard/DashboardRoute";
import QRCodesRoutes from "../components/pages/auth/QRCodesRoutes";

export const standardRoutes = [...DashboardRoutes, ...QRCodesRoutes];

export const guestRoutes = [...AuthRoutes, ...QRCodesRoutes];
